/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE SELECTOR TEMPLATE_URL AND CLASS NAME*/
import { Component } from '@angular/core'
import { BHTTPLoader } from '../service/bHTTPLoader';

@Component({
    selector: 'bh-spinner',
    templateUrl: './spinner.template.html',
      styles: [`
        .spinner {
            height: 2em;
            width: 2em;
            z-index: 999;
            position: fixed;
            overflow: show;
            margin: auto;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
        }

        /* Transparent Overlay */
        .spinner:before {
            content: '';
            display: block;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
           /* background-color: rgba(0,0,0,0.3);*/
        }


        .double-bounce1, .double-bounce2 {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background-color: #333;
            opacity: 0.6;
            position: absolute;
            top: 0;
            left: 0;

            -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
            animation: sk-bounce 2.0s infinite ease-in-out;
        }

        .double-bounce2 {
            -webkit-animation-delay: -1.0s;
            animation-delay: -1.0s;
        }

        @-webkit-keyframes sk-bounce {
            0%, 100% { -webkit-transform: scale(0.0) }
            50% { -webkit-transform: scale(1.0) }
        }

        @keyframes sk-bounce {
            0%, 100% {
                transform: scale(0.0);
                -webkit-transform: scale(0.0);
            } 50% {
                transform: scale(1.0);
                -webkit-transform: scale(1.0);
            }
        }
    `]
})

export class spinnerComponent  {
 public isHTTPRequestInProgress: boolean;
    constructor(private bHTTPLoader: BHTTPLoader){
        bHTTPLoader._isHTTPRequestInProgress$.subscribe((res) => {
            this.isHTTPRequestInProgress = res;
           // console.info("isHTTPRequestInProgress : "+res);
        });
    }

}



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/spinnerComponent/spinner.component.ts